import React from 'react';
import { PlayCircleIcon, ArrowRightIcon, ArrowDownIcon } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="w-full bg-jet-black text-white py-20 md:py-32 px-4 relative overflow-hidden" data-id="element-85">
      {/* Subtle grid background */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'linear-gradient(rgba(15,176,125,.3) 1px, transparent 1px), linear-gradient(90deg, rgba(15,176,125,.3) 1px, transparent 1px)',
      backgroundSize: '60px 60px'
    }} data-id="element-86" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-87">
        <div className="text-center space-y-8" data-id="element-88">
          {/* Proof chip */}
          <div className="inline-flex items-center gap-2 bg-viridia-green/15 border border-viridia-green/30 text-viridia-green px-4 py-2 rounded-full text-sm font-semibold" data-id="element-89">
            <span className="w-2 h-2 bg-viridia-green rounded-full animate-pulse" data-id="element-90" />
            One landscaping client books 3–5 extra estimates per week
            automatically
          </div>

          {/* Headline */}
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold leading-[1.1] tracking-tight" data-id="element-91">
            Stop Losing Online Leads to{' '}
            <span className="text-viridia-green relative" data-id="element-92">
              Slow Follow-Up
              <svg className="absolute -bottom-2 left-0 w-full" viewBox="0 0 300 12" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-93">
                <path d="M2 8C50 2 100 2 150 6C200 10 250 4 298 8" stroke="#0FB07D" strokeWidth="3" strokeLinecap="round" data-id="element-94" />
              </svg>
            </span>
          </h1>

          {/* Subheadline */}
          <p className="text-2xl md:text-3xl font-semibold text-gray-300 max-w-5xl mx-auto leading-snug" data-id="element-95">
            Instant Lead Response + Guided Booking for Yelp, Meta, and Google
            Leads—On Autopilot
          </p>

          {/* Supporting copy */}
          <p className="text-lg md:text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed" data-id="element-96">
            The growth engine built for landscapers, HVAC pros, and home service
            contractors who are paying for online leads but watching half of
            them go cold before anyone follows up.
          </p>

          {/* Video */}
          <div className="max-w-4xl mx-auto my-12" data-id="element-97">
            <div className="relative aspect-video rounded-xl overflow-hidden shadow-2xl border border-gray-700/50" data-id="element-98">
              <iframe src="https://www.youtube.com/embed/oxqLVR5ZiGM" title="Viridia Analytics Demo" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="absolute inset-0 w-full h-full" data-id="element-99" />
            </div>
          </div>

          {/* CTAs */}
          <div className="flex flex-col items-center pt-4" data-id="element-100">
            <a href="https://api.viridiaanalytics.com/widget/booking/hv5pIfS27zbJCMMGNnkJ" target="_blank" rel="noopener noreferrer" className="group px-10 py-5 bg-viridia-green text-white text-xl font-bold rounded-lg hover:bg-deep-teal hover:scale-105 hover:shadow-xl hover:shadow-viridia-green/20 transition-all duration-200 flex items-center gap-2" data-id="element-101">
              Book a Free Strategy Call
              <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-102" />
            </a>
            <p className="text-sm text-gray-400 mt-4 max-w-md leading-relaxed" data-id="element-103">
              Walk away knowing exactly where you're leaking leads and what it
              would take to fix it. 15 minutes. No pitch. No pressure.
            </p>
            <button onClick={scrollToPricing} className="mt-6 px-8 py-4 bg-transparent border-2 border-gray-500 text-gray-300 text-lg font-semibold rounded-lg hover:border-white hover:text-white hover:scale-105 transition-all duration-200 flex items-center gap-2" data-id="element-104">
              See Plans & Pricing
              <ArrowDownIcon className="w-5 h-5" data-id="element-105" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}